module.exports = __webpack_public_path__ + "e463be76da621d117a5be7c2f7b2d9eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/D@2x.png
// module id = 829
// module chunks = 0